import { useForm, Controller } from "react-hook-form";
import ScheduleInterviewCompanyRequestModel from "../../../models/company/addProfiles/request/ScheduleInterviewCompanyRequestModel";
import IdNameModel from "../../../models/common/IdNameModel";
import toasterUtils from "../../../utils/toaster-utils";
import dateTimeUtils from "../../../utils/date-utils";
import { FORM_SELECT_RULE } from "../../../utils/validation-utils";
import { Autocomplete, Box, Button, FormControl, Grid, Link, TextField, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import InterviewerDetailsForRescheduleModel from "../../../models/admin/interviews/response/InterviewerDetailsForRescheduleModel";
import addProfilesService from "../../../services/company/add-profiles-service";

interface ScheduleInterviewProps {
    objScheduleInterview: ScheduleInterviewCompanyRequestModel;
    timeSlotsList: IdNameModel[];
    onCloseScheduleInterview: () => void;
    onScheduleInterviewSave: (objScheduleInterview: ScheduleInterviewCompanyRequestModel) => void;
}

const ScheduleInterviewComponent = (props: ScheduleInterviewProps) => {
    const [interviewerSchedules, setInterviewerSchedules] = useState<InterviewerDetailsForRescheduleModel[]>([]);
    const [selectedInterviewer, setSelectedInterviewer] = useState<string>("");
    const [selectedTimeSlot, setSelectedTimeSlot] = useState<number>(0);

    const {
        register,
        control,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<ScheduleInterviewCompanyRequestModel>({
        mode: "onChange",
        defaultValues: {
            ...props.objScheduleInterview,
            scheduleInterviewRequestModel: {
                ...props.objScheduleInterview.scheduleInterviewRequestModel,
                interviewDate: props.objScheduleInterview?.scheduleInterviewRequestModel?.interviewDate
                    ? (dayjs(props.objScheduleInterview.scheduleInterviewRequestModel.interviewDate) as any)
                    : null,
            },
        },
    });

    useEffect(() => {
        if (props.objScheduleInterview?.scheduleInterviewRequestModel?.interviewDate) {
            getInterviewerSchedules(props.objScheduleInterview.scheduleInterviewRequestModel.interviewDate);
        }
    }, [props.objScheduleInterview]);

    const getInterviewerSchedules = (date: Date | null) => {
        if (date !== null) {
            setInterviewerSchedules([]);
            clearSelectedSlot();
            let dateString: string = dateTimeUtils.getFormattedDate(date);
            addProfilesService.getInterviewersForRequirement(props.objScheduleInterview.profileId, dateString).then((res) => {
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                setInterviewerSchedules(res.items);
            }).catch((error) => {
                toasterUtils.showError(error);
                setInterviewerSchedules([]);
            });
        }
    };

    const selectSlot = (timeSlotId: number, interviewerId: string) => {
        setSelectedTimeSlot(timeSlotId);
        setSelectedInterviewer(interviewerId);
    };

    const clearSelectedSlot = () => {
        setSelectedTimeSlot(0);
        setSelectedInterviewer("");
    };

    const onSubmit = (formData: ScheduleInterviewCompanyRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        if (formData.scheduleInterviewRequestModel.interviewDate === null) {
            toasterUtils.showError("Interview date is mandatory.");
        } else if (selectedInterviewer === "") {
            toasterUtils.showError("Please select an interviewer.");
        } else if (selectedTimeSlot === 0) {
            toasterUtils.showError("Please select a time slot.");
        } else {
            formData.scheduleInterviewRequestModel.interviewDateString = dateTimeUtils.getFormattedDate(formData.scheduleInterviewRequestModel.interviewDate);
            formData.scheduleInterviewRequestModel.candidateId = props.objScheduleInterview.profileId;
            formData.interviewerId = selectedInterviewer;
            formData.scheduleInterviewRequestModel.timeSlotId = selectedTimeSlot;
            //formData.scheduleInterviewRequestModel.interviewDate = dateTimeUtils.addDays(interviewDate, 1);;
            formData.scheduleInterviewRequestModel.interviewTypeId = props.objScheduleInterview.scheduleInterviewRequestModel.interviewTypeId;
            props.onScheduleInterviewSave(formData);
        }
    };

    return (
        <div className="card card-white">
            <div className="card-body">
                <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-md-4">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Controller name="scheduleInterviewRequestModel.interviewDate" control={control} rules={{ required: "Interview Date is required" }}
                                    render={({ field, fieldState }) => (
                                        <FormControl fullWidth margin="normal" error={!!fieldState.error}>
                                            <DatePicker
                                                label="Interview Date"
                                                value={field.value ? dayjs(field.value) : null}
                                                onChange={(newDate) => {
                                                    field.onChange(newDate);
                                                    getInterviewerSchedules(newDate ? newDate?.toDate() : null);
                                                }}
                                                format="YYYY-MMM-DD"
                                                minDate={dayjs()}
                                                slotProps={{
                                                    textField: {
                                                        size: "small",
                                                        fullWidth: true,
                                                        error: !!fieldState.error,
                                                        helperText: fieldState.error?.message,
                                                        onKeyDown: (e) => e.preventDefault(),
                                                    },
                                                }}
                                            />
                                        </FormControl>
                                    )}
                                />
                            </LocalizationProvider>
                        </div>
                        {/* <div className="col-md-4">
                            <Controller name="scheduleInterviewRequestModel.timeSlotId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                render={({ field }) => (
                                    <Autocomplete {...field} value={props.timeSlotsList.find(x => x.id === field.value) || null}
                                        onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={props.timeSlotsList} getOptionLabel={(option) => option.name || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Time Slot" size="small" required margin="normal" fullWidth error={!!errors.scheduleInterviewRequestModel?.timeSlotId} helperText={errors.scheduleInterviewRequestModel?.timeSlotId?.message} />
                                        )}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                    />
                                )}
                            />
                        </div> */}
                    </div>
                    {(selectedInterviewer === "" || selectedTimeSlot === 0) &&
                        <div className="row">
                            <div className="col-md-12">
                                {interviewerSchedules.map((interviewer) => (
                                    <Box mb={4}>
                                        <Typography variant="h6" className="interviewer-name-style">
                                            {interviewer.interviewerName}
                                        </Typography>
                                        <Grid container spacing={1} className="interviewer-slots-container">
                                            {interviewer.availableTimeSlots.map((slot, index) => (
                                                <Grid item key={index}>
                                                    <Link href="#" className={`interviewer-slots-style ${slot.isAvailable ? "available-slot" : ""}`}
                                                        onClick={(e) => selectSlot(slot.timeSlotId, interviewer.interviewerId)}>
                                                        {slot.timeSlotName}
                                                    </Link>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Box>
                                ))}
                            </div>
                        </div>
                    }
                    {selectedInterviewer !== "" && selectedTimeSlot !== 0 &&
                        <>
                            <div className="row">
                                <div className="col-md-4">
                                    <Typography variant="subtitle1">Selected Interviewer :</Typography>
                                </div>
                                <div className="col-md-6">
                                    <Typography variant="subtitle2" fontWeight="bold">
                                        {interviewerSchedules.find(ts => ts.interviewerId === selectedInterviewer)?.interviewerName}
                                    </Typography>
                                </div>
                                <div className="col-md-4">
                                    <Typography variant="subtitle1">Selected Time Slot :</Typography>
                                </div>
                                <div className="col-md-6">
                                    <Typography variant="subtitle2" fontWeight="bold">
                                        {interviewerSchedules.find(ts => ts.interviewerId === selectedInterviewer)?.availableTimeSlots.find(ts => ts.timeSlotId === selectedTimeSlot)?.timeSlotName}
                                    </Typography>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <Link href="#" className="choose-another-slot-link-style"
                                        onClick={(e) => clearSelectedSlot()}>
                                        Choose another slot
                                    </Link>
                                </div>
                                <div className="col-md-6">
                                    <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                                        Schedule Interview
                                    </Button>
                                    <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseScheduleInterview}>
                                        Close
                                    </Button>
                                </div>
                            </div>
                        </>
                    }
                    {/* <div className="row">
                        <div className="col-md-6"></div>
                        <div className="col-md-6">
                            <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                                Schedule Interview
                            </Button>
                            <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseScheduleInterview}>
                                Close
                            </Button>
                        </div>
                    </div> */}
                </form>
            </div>
        </div>
    );
};
export default ScheduleInterviewComponent;